import _sortBy from 'lodash/sortBy';
import { connect } from 'react-redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';

import ChatMenuModal, {
  ChatMenuModalFormValuesT,
} from '../../components/modals/chatmenu';

export type ChatMenuModalStatePropsT = {
  payload: ChatMenuModalFormValuesT;
  initialValues: ChatMenuModalFormValuesT;
};

const mapStateToProps = (
  _state: RootReducerStateT,
  ownProps: { node: { payload: ChatMenuModalFormValuesT } },
): ChatMenuModalStatePropsT => {
  let payload: ChatMenuModalFormValuesT = {
    buttons: [
      {
        button: '',
        nodeId: '',
      },
    ],
    text: '',
  };

  if (ownProps.node.payload?.buttons) {
    payload = {
      buttons: [],
      text: ownProps.node.payload.text,
    };

    payload.buttons = _sortBy(ownProps.node.payload.buttons, 'order');
  }

  return {
    payload,
    initialValues: payload,
  };
};

export default connect(mapStateToProps)(ChatMenuModal);
